import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { isMobileApp } from './device';
import { Auth, PhoneAuthProvider, RecaptchaVerifier } from 'firebase/auth';

export const customAuthPhoneNumberVerify = async (
  auth: Auth,
  phoneNumber: string,
  recaptcha: RecaptchaVerifier
): Promise<string> => {
  if (!isMobileApp()) {
    const provider = new PhoneAuthProvider(auth);

    const verificationId = await provider.verifyPhoneNumber(
      phoneNumber,
      recaptcha
    );

    return verificationId;
  }

  console.log('CALLING CUSTOM AUTH PLUGIN');
  return new Promise(async (resolve, reject) => {
    try {
      await FirebaseAuthentication.addListener('phoneCodeSent', async (e) => {
        console.log('Phone code sent event', e);
        resolve(e.verificationId);
      });

      console.log('Calling custom auth phone number verify');
      await FirebaseAuthentication.signInWithPhoneNumber({ phoneNumber });
    } catch (e) {
      reject(e);
    }
  });
};
